module.exports = __webpack_public_path__ + "img/add-user.86d18afb.svg";